import useScroll from 'hooks/useScroll';
import { useEffect, useState } from 'react';
import Btn, { BtnModifier } from './btn';
import ArrowUpIcon from '../assets/icons/arrowUp.svg';

function ScrollTop() {
  const { scrollY } = useScroll();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const windowHeight = window.innerHeight;
    const scrollOffset = window.scrollY;

    setShowButton(scrollOffset >= windowHeight / 2);
  }, [scrollY]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    showButton ? (
      <div className="ct_scrollTop">
        <div className="ct_section">
          <div className="ct_scrollTop-inner">
            <div className="ct_scrollTop-actions">
              <Btn type="primary" text="" icon={<ArrowUpIcon />} modifier={[BtnModifier.SCROLL_TOP]} onClick={() => scrollToTop()} />
            </div>
          </div>
        </div>
      </div>
    ) : null
  );
}

export default ScrollTop;
